import main from './users.svg';
import active from './users-filled.svg';
import disabled from './users-gestalt.svg';

export default { main, active, disabled };
